export const discouts = {
    state: {
        categories: [],
        discounts: []
    },
    mutations: {
        SET_DISCOUNT_CATEGORIES(state, categories) {
            state.categories = categories
        },
        SET_DISCOUNTS(state, discounts) {
            state.discounts = discounts
        }
    },
    actions: {
        fetchDiscountCategories({ commit, getters }) {
            return new Promise((resolve, reject) => {
                this.$api.get('b2b/v2/management/product_discount_categories').then(response => {
                    commit('SET_DISCOUNT_CATEGORIES', response.data.data)
                    resolve()
                })
            })
        },
        fetchDiscounts({ commit, getters }) {
            return new Promise((resolve, reject) => {
                this.$api.get('b2b/v2/management/discounts').then(response => {
                    commit('SET_DISCOUNTS', response.data.data)
                    resolve()
                })
            })
        }
    },
    getters: {
        discountCategories: (state) => {
            return state.categories
        },
        discounts: (state) => {
            return state.discounts
        },
        getDiscount: (state, getters) => (discountCategory, dayInWeek, addressId) => {
            const weeksWithRanges = state.discounts[discountCategory]
            if(weeksWithRanges !== undefined) {
                const week = weeksWithRanges.find(week => {
                    const totalAmount = getters.weekDayOrderSumWithoutDiscount(dayInWeek, addressId)
                    const minOperator = week.range_raw[0]
                    const maxOperator = week.range_raw.slice(-1)
                    if (week.range[1] === null) {
                        week.range[1] = 1000000
                    }

                    if (week.range[0] === null) {
                        week.range[0] = 0
                    }

                    if(minOperator === '[' && maxOperator === ')') {
                        return totalAmount < week.range[1] && totalAmount >= week.range[0]
                    }
                    if(minOperator === '[' && maxOperator === ']') {
                        return totalAmount < week.range[1] && totalAmount > week.range[0]
                    }
                    if(minOperator === '(' && maxOperator === ')') {
                        return totalAmount <= week.range[1] && totalAmount >= week.range[0]
                    }
                    if(minOperator === '(' && maxOperator === ']') {
                        return totalAmount <= week.range[1] && totalAmount > week.range[0]
                    }
                })
                let discount = 0
                if(week) {
                    switch(dayInWeek) {
                    case 0:
                        discount = week.monday
                        break
                    case 1:
                        discount = week.thuesday
                        break
                    case 2:
                        discount = week.wednesday
                        break
                    case 3:
                        discount = week.thursday
                        break
                    case 4:
                        discount = week.friday
                        break
                    case 5:
                        discount = week.sunday
                        break
                    case 6:
                        discount = week.saturday
                        break
                    default:
                        discount = 0
                    }
                }
                return discount
            }
        }
    }
}
